// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"86":"f6487a47","227":"3b1e02db","353":"df6c7474","433":"2bf43e79","811":"d7196733","840":"de48620b"}[chunkId] + ".js";
};